import PropTypes from 'prop-types';

export const sectionPropType = PropTypes.shape({
    name: PropTypes.string,
    exercisesCount: PropTypes.number,
    time: PropTypes.number,
});
